module.exports = __webpack_public_path__ + "img/5A643B_454D2C_393F25_202315-256px.ed7fa22e.png";